// Module
var code = "<a href ng-attr-title=\"{{ match.model.name }}\"> <span ng-bind-html=\"match.model.name | uibTypeaheadHighlight:query\"></span> <small ng-if=match.model.creditorId>({{match.model.creditorId | uppercase}})</small> </a> ";
// Exports
var _module_exports = code;;
var path = 'app/common/ui/paymentPartners/paymentPartnersSuggest.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;